export const COPY_ROLE_ID = 1;

export const COPY_NAME_CELL = "tt-copy-name";

export const COPY_EXCLUDE = "tt-copy-exclude";

export const GUARD_CLASS = "tt-copy-guard";

export const NAMES_CLASS = "tt-copy-names";

const asElement = (node: Node | null): Element | null =>
  node == null
    ? null
    : node.nodeType === Node.ELEMENT_NODE
      ? (node as Element)
      : node.parentElement;

export function isNameCellSelection(): boolean {
  const selection = window.getSelection();
  if (!selection || selection.isCollapsed || selection.rangeCount === 0) {
    return false;
  }

  for (let i = 0; i < selection.rangeCount; i++) {
    const range = selection.getRangeAt(i);
    if (range.collapsed) continue;
    const el = asElement(range.commonAncestorContainer);
    if (!el?.closest(`td.${COPY_NAME_CELL}`)) return false;
  }

  return selection.toString().trim().length > 0;
}
